import React from "react";
import { ArrowRight, MessageSquareText, ThermometerSnowflake } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CriticalEnvironmentsEngineering() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="engenharia-de-ambientes-críticos" ref={sectionRef} className="dark bg-background text-foreground relative min-h-[85vh] flex items-center overflow-hidden py-20 lg:py-0">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05]">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
          <defs>
            <pattern id="blueprint-grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#blueprint-grid)" />
        </svg>
      </div>

      {}
      <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-primary/15 blur-[120px] rounded-full pointer-events-none mix-blend-screen" />
      <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-secondary/10 blur-[100px] rounded-full pointer-events-none mix-blend-screen" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {}
          <div className={`lg:col-span-7 flex flex-col gap-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/30 w-fit">
              <ThermometerSnowflake className="w-4 h-4 text-primary" />
              <span className="text-xs font-medium tracking-wider uppercase text-primary">
                Engenharia Térmica Especializada
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight text-white">
              Engenharia térmica e controle de temperatura e umidade para
              aplicações críticas
              <span className="text-secondary">.</span>
            </h1>

            <p className="text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">
              Projetos, equipamentos e serviços com confiabilidade para ambientes
              médico-hospitalares, salas limpas, telecom/datacenter e processos
              industriais.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mt-4">
              <Button asChild variant="default" size="lg" className="text-base font-semibold shadow-2xs transition-all duration-300">
                <Link to="/ContactPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive bg-primary h-10 rounded-md px-6 has-[>svg]:px-4 text-base font-semibold shadow-2xs transition-all duration-300 !text-[hsl(0,0%,0%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90">Solicitar Proposta</Link>
              </Button>

              <Button asChild variant="ghost" size="lg" className="text-base font-medium border border-white/10 hover:bg-white/5 hover:text-white shadow-2xs">
                <Link to="/ContactPage">
                  <MessageSquareText className="mr-2 w-5 h-5" />
                  Falar com Engenharia
                </Link>
              </Button>
            </div>

            {}
            <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mt-8 pt-8 border-t border-white/10">
              <div data-index="0">
                <p className="text-3xl font-bold text-white">+36</p>
                <p className="text-sm text-muted-foreground">Anos de Experiência</p>
              </div>
              <div data-index="1">
                <p className="text-3xl font-bold text-white">ISO</p>
                <p className="text-sm text-muted-foreground">Qualidade Certificada</p>
              </div>
              <div data-index="2" className="hidden md:block">
                <p className="text-3xl font-bold text-white">24/7</p>
                <p className="text-sm text-muted-foreground">Suporte Técnico</p>
              </div>
            </div>
          </div>

          {}
          <div className={`lg:col-span-5 relative transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
            {}
            <div className="relative z-10 group">
              {}
              <div className="absolute -inset-4 border border-white/10 rounded-xl bg-card/5 backdrop-blur-sm -z-10 transform rotate-2 transition-transform duration-500 group-hover:rotate-1" />
              
              {}
              <div className="relative rounded-lg overflow-hidden shadow-2xs border border-white/10 bg-black/20">
                <img src="https://doctorice.10web.cloud/wp-content/uploads/2026/03/Projeto-sem-titulo.jpg" alt="Unidade de refrigeração de alta tecnologia para ambientes críticos" className="w-full h-auto object-cover transform transition-transform duration-700 hover:scale-105" />
                
                {}
                <div className="absolute top-4 right-4 flex flex-col gap-2">
                  <div className="h-1.5 w-12 bg-secondary/60 rounded-full animate-pulse" />
                  <div className="h-1.5 w-8 bg-primary/40 rounded-full" />
                </div>
                
                <div className="absolute bottom-6 left-6 bg-black/60 backdrop-blur-md border border-white/10 p-3 rounded-md">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                    <span className="text-xs font-mono text-white/90">SYSTEM_ACTIVE</span>
                  </div>
                  <div className="text-xs font-mono text-muted-foreground mt-1">
                    TEMP: 21.5°C | HUM: 45%
                  </div>
                </div>
              </div>
            </div>

            {}
            <div className="absolute -top-12 -right-12 w-64 h-64 border border-dashed border-white/10 rounded-full animate-[spin_60s_linear_infinite] pointer-events-none" />
            <div className="absolute -bottom-8 -left-8 w-32 h-32 border border-white/5 rounded-full pointer-events-none" />
          </div>
        </div>
      </div>
    </section>;
}